import { Box, Button, IconButton, Sheet, Stack, Tooltip, Typography } from "@mui/joy";
import FileUploadRoundedIcon from "@mui/icons-material/FileUploadRounded";
import { useContext, useState, useEffect } from "react";
import { LayoutContext } from "../../context";
import { bookApi } from "../../api";
import { logUi } from "../../logger";
import ShoppingCartRoundedIcon from "@mui/icons-material/ShoppingCartRounded";
import CheckCircleRoundedIcon from "@mui/icons-material/CheckCircleRounded";
import LibraryBooksRoundedIcon from "@mui/icons-material/LibraryBooksRounded";
import AspectRatioRoundedIcon from "@mui/icons-material/AspectRatioRounded";
import AddShoppingCartRoundedIcon from "@mui/icons-material/AddShoppingCartRounded";
import CardGiftcardRoundedIcon from "@mui/icons-material/CardGiftcardRounded";
import ArrowBackRoundedIcon from "@mui/icons-material/ArrowBackRounded";
import InfoOutlineRoundedIcon from '@mui/icons-material/InfoOutlineRounded';
import ContactSupportRoundedIcon from '@mui/icons-material/ContactSupportRounded';
import PriorityHighRoundedIcon from '@mui/icons-material/PriorityHighRounded';

import TelegramIcon from "@mui/icons-material/Telegram";
import CloseRoundedIcon from "@mui/icons-material/CloseRounded";
import Modal from "@mui/joy/Modal";
import ModalDialog from "@mui/joy/ModalDialog";



export default function Header({ handleCheckout, onAddToCart, onChangeFormat, onMyBooks, onGift, onBack }) {
    const { bookSize, bookId, setShowOnboarding, cartItems, showCartModal, setShowSizeModal, setShowExportModal, setShowMyBooksModal } = useContext(LayoutContext);
    const [showSupportModal, setShowSupportModal] = useState(false);
    const [supportCode, setSupportCode] = useState(null);
    const [codeLoading, setCodeLoading] = useState(false);
    const [codeCopied, setCodeCopied] = useState(false);

    useEffect(() => {
        if (!showSupportModal) return;
        logUi("open_support", "Открыл модалку техподдержки");
        setCodeCopied(false);
        setCodeLoading(true);
        bookApi.getSupportCode()
            .then((res) => setSupportCode(res.code))
            .catch(() => setSupportCode(null))
            .finally(() => setCodeLoading(false));
    }, [showSupportModal]);

    const copyCode = () => {
        if (!supportCode) return;
        try { navigator.clipboard && navigator.clipboard.writeText(supportCode); } catch (e) {}
        setCodeCopied(true);
        logUi("copy_support_code", "Скопировал код техподдержки", { code: supportCode });
    };

    return (
        <>
            <Sheet
                variant="outlined"
                sx={{
                    height: 56, px: { xs: 2, sm: 3 }, borderRadius: 0,
                    borderTop: "none", borderLeft: "none", borderRight: "none",
                    borderColor: "divider", bgcolor: "background.surface",
                    display: "flex", alignItems: "center", justifyContent: 'space-between', gap: { xs: 1, sm: 1.5 }, flexShrink: 0, zIndex: 100,
                }}
            >
                <Stack direction="row" sx={{ gap: 0.5 }} alignItems={'center'}>
                    {/* Кнопка назад */}
                    {bookId && (
                        <IconButton
                            size="sm"
                            variant="plain"
                            color="neutral"
                            onClick={onBack}
                            sx={{
                                borderRadius: "10px",
                                mr: 0.5,
                            }}
                        >
                            <ArrowBackRoundedIcon sx={{ fontSize: 20 }} />
                        </IconButton>
                    )}

                    <Stack direction="row" sx={{ gap: 1 }} alignItems={'center'}>
                        <Box
                            component={'img'}
                            src="/logo_black.png"
                            alt="Логотип"
                            sx={{ height: 23, ml: 0.5 }}
                        />
                        
                        <Tooltip title="Начать с начала" size="sm">
                            <IconButton sx={{ borderRadius: '50%', py: 0 }} variant="outlined" color="neutral" size="sm" onClick={() => setShowOnboarding(true)}>
                                <PriorityHighRoundedIcon sx={{ fontSize: 17, py: 0 }} />
                            </IconButton>
                        </Tooltip>
                    </Stack>
                </Stack>

                
                <Stack direction="row" sx={{ gap: 0.5 }} alignItems={'center'}>   
                    <Tooltip title="Поддержка" size="sm">
                        <IconButton sx={{ borderRadius: 10, py: 0 }} variant="outlined" color="neutral" size="md" onClick={() => setShowSupportModal(true)}>
                            <ContactSupportRoundedIcon sx={{ fontSize: 20, py: 0 }} />
                        </IconButton>
                    </Tooltip>
                    {/* Оформить заказ */}
                    <Button
                        size="sm"
                        startDecorator={<CheckCircleRoundedIcon />}
                        onClick={handleCheckout}
                        disabled={!bookId && cartItems.length === 0}
                        sx={{ borderRadius: "10px", fontWeight: 600 }}
                    >
                        Оформить
                    </Button>
                </Stack> 
            </Sheet>

            {/* Модалка тех. поддержки */}
            <Modal open={showSupportModal} onClose={() => setShowSupportModal(false)} sx={{ zIndex: 10010 }}>
                <ModalDialog
                    sx={{
                        maxWidth: 360,
                        borderRadius: "20px",
                        p: 3,
                        textAlign: "center",
                        boxShadow: "0 8px 40px rgba(0,0,0,0.12)",
                    }}
                >
                    {/* Кнопка закрытия */}
                    <IconButton
                        size="sm"
                        variant="plain"
                        color="neutral"
                        onClick={() => setShowSupportModal(false)}
                        sx={{ position: "absolute", top: 12, right: 12 }}
                    >
                        <CloseRoundedIcon />
                    </IconButton>

                    {/* Иконка */}
                    <Box sx={{
                        width: 56, height: 56, borderRadius: "50%", mx: "auto", mb: 2,
                        bgcolor: "#F7EFF3",
                        display: "flex", alignItems: "center", justifyContent: "center",
                    }}>
                        <ContactSupportRoundedIcon sx={{ fontSize: 28, color: "#682243" }} />
                    </Box>

                    <Typography level="title-lg" sx={{ fontWeight: 800, mb: 0.5 }}>
                        Техническая поддержка
                    </Typography>
                    <Typography level="body-sm" sx={{ color: "text.secondary", mb: 2 }}>
                        Выберите удобный способ связи — мы ответим как можно скорее
                    </Typography>

                    {/* Код для техподдержки */}
                    <Box sx={{
                        mb: 2.5, p: 1.5, borderRadius: "12px",
                        bgcolor: "#F7EFF3", border: "1px solid", borderColor: "#E5CED9",
                    }}>
                        <Typography level="body-xs" sx={{ color: "text.tertiary", mb: 0.5 }}>
                            Назовите оператору код:
                        </Typography>
                        <Typography level="h3" sx={{ fontWeight: 800, letterSpacing: "6px" }}>
                            {codeLoading ? "······" : (supportCode || "—")}
                        </Typography>
                        <Button
                            size="sm" variant="soft" color="neutral"
                            onClick={copyCode}
                            disabled={!supportCode}
                            sx={{
                                mt: 1, borderRadius: "10px",
                                bgcolor: "#F7EFF3", color: "#682243",
                                "&:hover": { bgcolor: "#E5CED9" },
                            }}
                        >
                            {codeCopied ? "Скопировано" : "Скопировать код"}
                        </Button>
                    </Box>

                    <Stack direction="column" spacing={1.5}>
                        <Button
                            component="a"
                            href="https://t.me/NIKOLYA_KAFYAN"
                            target="_blank"
                            rel="noopener noreferrer"
                            onClick={() => logUi("support_telegram", "Перешёл в Telegram поддержки", { code: supportCode })}
                            variant="solid"
                            size="lg"
                            startDecorator={<TelegramIcon />}
                            sx={{
                                borderRadius: "12px",
                                fontWeight: 700,
                                bgcolor: "#682243",
                                color: "#ffffff",
                                "&:hover": { bgcolor: "#541B36", color: "#ffffff", transform: "scale(1.02)" },
                            }}
                        >
                            Telegram
                        </Button>

                        <Button
                            component="a"
                            href="https://max.ru/u/f9LHodD0cOIDfBe70-cGbfYLKqFtxzvZkEELuNXhjniQlaK-XDamsiIFq-s"
                            target="_blank"
                            rel="noopener noreferrer"
                            onClick={() => logUi("support_max", "Перешёл в Max поддержки", { code: supportCode })}
                            variant="solid"
                            size="lg"
                            startDecorator={
                                <img src="./icon-max.png" alt="Max" style={{ width: 20, height: 20 }} />
                            }
                            sx={{
                                borderRadius: "12px",
                                fontWeight: 700,
                                bgcolor: "#682243",
                                color: "#ffffff",
                                "&:hover": { bgcolor: "#541B36", color: "#ffffff", transform: "scale(1.02)" },
                            }}
                        >
                            Max
                        </Button>
                    </Stack>
                </ModalDialog>
            </Modal>
        </>
    )
}